import React from "react";

interface MarkerLabelProps {
  text?: string;
  markerPercent?: number; // Wert zwischen 0 und 4
}

/**
 * MarkerLabel: Text + Pfeil über dem MarkerDot
 * text: anzeigender Text (default: "We are here")
 * markerPercent: Wert zwischen 0 und 4 (4 = 100%)
 */
const MarkerLabel: React.FC<MarkerLabelProps> = ({
  text = "We are here",
  markerPercent = 0,
}) => {
  // Umrechnung: 0-4 → 0-100%
  const percentPosition = (markerPercent / 4) * 100;

  return (
    <div className="marker-label">
      <div className="marker-wrapper" style={{ left: `${percentPosition}%` }}>
        <span className="marker-label-text">{text}</span>
        <svg
          className="marker-label-arrow"
          width={14}
          height={11}
          viewBox="0 0 14 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.00032 10.5L0.938146 -1.05994e-06L13.0625 0L7.00032 10.5Z"
            fill="#222"
          />
        </svg>
      </div>
    </div>
  );
};

export default MarkerLabel;
